import React from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';
import { formatDateToYYYYMMDD } from '../../../../utils/dateUtils';
import type { DeleteCampaignModalProps } from './types';
import { getCampaignStatusText } from './types';

const DeleteCampaignModal: React.FC<DeleteCampaignModalProps> = ({
  show,
  campaign,
  onHide,
  onConfirm,
  isDeleting = false,
}) => {
  if (!campaign) {
    return null;
  }

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Delete Campaign</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Alert variant="danger">
          <Alert.Heading>Are you sure?</Alert.Heading>
          <p>
            You are about to delete the campaign <strong>"{campaign.name}"</strong>.
          </p>
          <hr />
          <div className="mb-2">
            <strong>Campaign Details:</strong>
          </div>
          <ul className="mb-0">
            <li>
              <strong>ID:</strong> {campaign.id}
            </li>
            <li>
              <strong>Status:</strong> {getCampaignStatusText(campaign.status)}
            </li>
            <li>
              <strong>Period:</strong> {formatDateToYYYYMMDD(campaign.startAt)} - {formatDateToYYYYMMDD(campaign.endAt)}
            </li>
          </ul>
        </Alert>

        <div className="bg-light p-3 rounded">
          <div className="d-flex align-items-center">
            <i className="bi bi-exclamation-triangle text-warning me-2"></i>
            <div>
              <strong>Warning:</strong> This action cannot be undone. All campaign data will be permanently removed.
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={isDeleting}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onConfirm} disabled={isDeleting}>
          {isDeleting ? 'Deleting...' : 'Delete Campaign'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteCampaignModal;
